import { Component } from '@angular/core';
import { NavController, NavParams, IonicPage } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import * as $ from 'jquery'
import { AudioProvider } from 'ionic-audio';
import { ExhibitionPage } from '../../pages/exhibition/exhibition';

@IonicPage({
  name: 'spot',
  segment: 'spot/:muzeum',
  defaultHistory: ['Home']
})
@Component({
  selector: 'page-spot',
  templateUrl: 'spot.html'
})
export class SpotPage {
  id;
  spot:any = {

    src: ''

  };



  bgImg="";
  textData = "";
  src="";
  choosenColor="";
  exhibition;
  spotType = "";
  autoPlay = false;
  exhibitionNname;
  playShow = false;
  btnEnter;
  currentTrack;
  exhibitionID = '';
  exhibitionColor;
  activeBoard = false;
  activePlayer = false;

  showAudio = false;
  showText = false;
  
  workName:any = false;
  dis:any = false;
  year:any = false;
  moreInfo:any = false;
  credit:any = false;
  srcAudio = ''



  

  lang='';
  constructor(
    public navCtrl: NavController,
     public navParams: NavParams,
      private _DataProvider: DataProvider,
      private _audioProvider: AudioProvider) {
        if(!this._DataProvider.getLocalStorage('lang')){

          this._DataProvider.setLocalStorage('lang',"he");
    
        }
        
        if(this.navParams.get('muzeum') && !this._DataProvider.getLocalStorage('muzeum')){
  
          this._DataProvider.setLocalStorage('muzeum',this.navParams.get('muzeum'));
    
        }else{
          if(!this.navParams.get('muzeum') && !this._DataProvider.getLocalStorage('muzeum')){
          this.navCtrl.setRoot("Welcome")
    
          }
        }


  }

PauseAudio(){
  document.getElementById('pauseBTN').click();
}


ngOnInit(){
  // this._DataProvider.currentPage = 'spot'

 




}



ionViewDidEnter() {
  this._DataProvider.currentPage = 'spot'

}

ionViewCanLeave() {
this.PauseAudio();
}

checkText(){
  if(this.showText){
    return true;
  }else{
    return false;
  }
}

checkAudio(){
  if(this.showAudio && this.srcAudio != '' ){
    return true;
  }else{
    return false;
  }
}
 
checkdis(){
  if(this.dis){
    return true;
  }else{
    return false;
  }
}

checkworkName(){
  if(this.workName){
    return true;
  }else{
    return false;
  }
}

checkyear(){
  if(this.year){
    return true;
  }else{
    return false;
  }
}

checkmoreInfo(){
  if(this.moreInfo){
    return true;
  }else{
    return false;
  }
}

checkcredit(){
  if(this.credit){
    return true;
  }else{
    return false;
  }
}

  ionViewDidLoad() {


    this.exhibitionID = this._DataProvider.getLocalStorage('exhibitionID');
    this.spotType = this._DataProvider.getLocalStorage('spotType');
    this.id = this._DataProvider.getLocalStorage('selectedSpotID');
    console.log('sadjsaldkjsakdjlksajdlakj');
  
    this._DataProvider.showPad = false;
    console.log('lhjlkjlkjlkjlkjlkj');
    
    
       this.getSpotFunc(this.id);
 }// end of ionViewDidLoad
  

defaultSize = 18;

  onTrackFinished(track: any) {
    console.log('Track finished', track)
    this._DataProvider.setStatstic("finish spot");
  } 

  sizeText(direction){
    console.log(direction,this.defaultSize);
    if(this.defaultSize>=14 && this.defaultSize <= 33 ){
    if(direction == 'plus'){
      if(this.defaultSize!=33){
        this.defaultSize++;
      }
    }else{
      if(this.defaultSize!=14){
        this.defaultSize--;
      }
    }

  }//
  }

  goToCode(){
    this.navCtrl.setRoot(ExhibitionPage, {
      muzeum:this._DataProvider.Muzeum.urlCode,
    })
  }   
  



  getDirection(){
    if(this.lang=='he'){
      return 'rtl';
    }else{
      return 'ltr';
    }
  }

  digits = [" ", " ", " "];
  digitsIndex = 0;
  result;
  spotName="";





getSpotFunc(spotID){
console.log('asdasd');

console.log('spotID: ',spotID)
console.log('spotsList: ',this._DataProvider.spotsList);
if(this._DataProvider.spotsList){
  let filteredSpot = this._DataProvider.spotsList.filter(element => element.id == spotID);
  console.log(filteredSpot);
  this.spot = filteredSpot[0]; 
  this.activePlayer = true;
console.log('this.spot:',this.spot);
this.bgImg=this.spot.bgImg;
this.src=this.spot.src;
this.choosenColor=this.spot.choosenColor;
this.srcAudio=this.spot.src;







if(this.spot.hasOwnProperty('workName')){
  if(this.spot.workName!=''){
    this.workName = this.spot.workName;
  }else{
    this.workName = false;
  }
  }else{
    this.workName = false;
  }


  if(this.spot.hasOwnProperty('year')){
    if(this.spot.year!=''){
      this.year = this.spot.year;
    }else{
      this.year = false;
    }
    }else{
      this.year = false;
    }


  if(this.spot.hasOwnProperty('dis')){
    if(this.spot.dis!=''){
      this.dis = this.spot.dis;
    }else{
      this.dis = false;
    }
    }else{
      this.dis = false;
    }

    if(this.spot.hasOwnProperty('moreInfo')){
      if(this.spot.moreInfo!=''){
        this.moreInfo = this.spot.moreInfo;
      }else{
        this.moreInfo = false;
      }
      }else{
        this.moreInfo = false;
      }




if(this.spot.hasOwnProperty('showAudio')){
  if(this.spot.showAudio){
    this.showAudio = this.spot.showAudio;
  }
  
}else{
  console.log('have no hasOwnProperty   showAudio');
  this.showAudio = true;
}

if(this.spot.showText){
  this.textData = this.spot.textData;
  this.showText = this.spot.showText;
}else{
  this.showText = false;
}



document.querySelector("meta[name=theme-color]").setAttribute("content", this.choosenColor);

console.log(this.spot.src,this.spot.name);
this.currentTrack = {
  src: this.spot.src,
  title: this.spot.name,
  preload: 'metadata' // tell the plugin to preload metadata such as duration for this track, set to 'none' to turn off
 };


}else{


let self = this;

this._DataProvider.FBcol.collection('spots').doc(spotID).ref.get().then(function(doc) {
  if (doc.exists) {
      console.log("Document data:", doc.data());
      const res = doc.data();
      console.log('res',res);
      self.spot = res; 
      self.textData = res.textData;
      self.lang = res.lang;
      self.srcAudio=res.src;




      if(res.hasOwnProperty('credit')){
      if(res.credit!=''){
        self.credit = res.credit;
      }else{
        self.credit = false;
      }
      }else{
        self.credit = false;
      }




      if(res.hasOwnProperty('workName')){
      if(res.workName!=''){
        self.workName = res.workName;
      }else{
        self.workName = false;
      }
      }else{
        self.workName = false;
      }


      if(res.hasOwnProperty('year')){
        if(res.year!=''){
          self.year = res.year;
        }else{
          self.year = false;
        }
        }else{
          self.year = false;
        }


      if(res.hasOwnProperty('dis')){
        if(res.dis!=''){
          self.dis = res.dis;
        }else{
          self.dis = false;
        }
        }else{
          self.dis = false;
        }

        if(res.hasOwnProperty('moreInfo')){
          if(res.moreInfo!=''){
            self.moreInfo = res.moreInfo;
          }else{
            self.moreInfo = false;
          }
          }else{
            self.moreInfo = false;
          }




    if(res.hasOwnProperty('showAudio')){
      if(res.showAudio){
        self.showAudio = res.showAudio;
      }
      
    }else{
      console.log('have no hasOwnProperty   showAudio');
      self.showAudio = true;
    }

    if(res.showText){
      self.showText = res.showText;
    }else{
      self.showText = false;
    }

      self.activePlayer = true;
      
    console.log('self.spot:',self.spot);
    self.bgImg=self.spot.bgImg;
    self.src=self.spot.src;
    self.choosenColor=self.spot.choosenColor;
    document.querySelector("meta[name=theme-color]").setAttribute("content", self.choosenColor);
    
    console.log(self.spot.src,self.spot.name);
    self.currentTrack = {
      src: self.spot.src,
      title: self.spot.name,
      preload: 'metadata' // tell the plugin to preload metadata such as duration for this track, set to 'none' to turn off
     };


    } else {
      console.log("No such document!");
  }
}).catch(function(error) {
    console.log("Error getting document:", error);
});
}// end of else exsitst in data service

}




// this._DataProvider.getSpotByID(spotID)
// .subscribe(res => {
//   console.log(res);
//   this.spot = res["theResult"][0]; 
//   this.activePlayer = true;
// console.log(this.spot);
//   this.bgImg=this.spot.bgImg;
// this.src=this.spot.src;
// this.choosenColor=this.spot.choosenColor;
// document.querySelector("meta[name=theme-color]").setAttribute("content", this.choosenColor);


// this.currentTrack = {
//   src: this.spot.src,
//   title: this.spot.name,
//   preload: 'metadata' // tell the plugin to preload metadata such as duration for this track, set to 'none' to turn off
//  };
 
// this._DataProvider.getExhibitionByID(this.spot.ExhibitionsID)
// .subscribe(res => {
//   console.log(res);
//   this.exhibition = res["theResult"][0];
//   console.log(this.exhibition);
//   this.spotType = this.exhibition.spotType;
//   this.autoPlay = this.exhibition.autoPlay;
//   if(this.autoPlay){
//     this.playShow = true;
//   }



//     });


//});// end of getSpotByID

// }



// clickOnBtnEnter(){
//   this.activeBoard = !this.activeBoard;

// }


  // clickNum(numClicked) {
  //   console.log('numClicked', numClicked);
  //   if (numClicked != 'delete') {
  //     // is a number
  //     console.log('digitsIndex', this.digitsIndex);
  //     if (this.digitsIndex == 2) {
  //       console.log('ask for data');
  //       this.digits[this.digitsIndex] = numClicked;
  //       this.digitsIndex++;
  //       console.log(this.exhibition);
  //       console.log(this.id);
      
  //       //asking for data
  //      this._DataProvider.getSpotByExebitionCodeAndLang(this._DataProvider.Muzeum._id,this.digits[0].toString() +this.digits[1].toString() +this.digits[2].toString() ,this.exhibition.lang)
  //      .subscribe(res => {
  //         console.log(res);
  //         this.result = res["theResult"];
   
  //         console.log(this.result);
  //         if(this.result.length != 0){
  //           this.PauseAudio();
  //           this.bgImg=this.result[0]["bgImg"];
  //          this.spotName = this.result[0]["name"];
  //         // this.btnEnterShow=true;
  //         this.getSpotFunc(this.result[0]["_id"]);
  //         this._DataProvider.setLocalStorage('selectedSpotID',this.result[0]["_id"]);

  //          this._DataProvider.selectedSpot = this.result[0];
  //         }else{
  //           //do the not found here
  //           console.log("could not get !!");
  //         }

  //           }); 
      
      
   
    


  //     } else if (this.digitsIndex > 2) {
  //       console.log('no more -- light up the delete animation');
  //     } else {
  //       this.digits[this.digitsIndex] = numClicked;
  //       this.digitsIndex++;
  //     }//end of check index
  //   } else {
  //     // is delete
  //     console.log('digitsIndex', this.digitsIndex);
  //     if ( this.bgImg != this.exhibition.bgImg){
  //       console.log('this.bgImg !=');
  //      // this.spotName = "";
  //      // this._DataProvider.selectedSpot = {"_id":""};
  //      // this.btnEnterShow=false;
  //    //   this.bgImg = this.exhibition.bgImg;
  //      // this.activePlayer = false;

  //     }


  //     if (this.digitsIndex != 0) {
  //       this.digitsIndex--;
  //       this.digits[this.digitsIndex] = " ";
  //     } 
      

  //   }
  // }





}



// WEBPACK FOOTER //
// ./src/pages/spot/spot.ts